















































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class UserQuestionsPost extends Vue {
	title = "";
	description = "";
	tags = "";
	loading = false;

	instructions = [
		{
			title: "summerize the problem.",
			body:
				"Try to include detail explanation in the detail field, describe expected results..."
		},
		{
			title: "Describe why?",
			body:
				"Try to include description why your asking this qustion and use cliean gramatic order in describing your questions"
		},
		{
			title: "show or give some examples.",
			body:
				"Try to give example or scenario of the problem that you want to ask"
		}
	];

	clear() {
		this.title = "";
		this.description = "";
		this.tags = "";
		(this.$refs.createQuestionObserver as Vue & {
			reset: () => boolean;
		}).reset();
	}

	submit() {
		this.loading = true;
		(this.$refs.createQuestionObserver as Vue & {
			validate: () => any;
		})
			.validate()
			.then((isValid: boolean) => {
				if (isValid) {
					const info: any = {
						title: this.title,
						description: this.description,
						tags: this.tags
					};
					console.log("ok the input is valid now lets dispatch it", info);
					this.$store
						.dispatch("qa/createQuestionPost", info)
						.then(res => {
							console.log(res);
							this.loading = false;
							this.$router.push({ name: "QA" });
						})
						.catch(err => {
							setTimeout(() => (this.loading = false), 2000);
							console.log(err);
						});
				} else {
					setTimeout(() => (this.loading = false), 2000);
				}
			})
			.catch((error: any) => {
				setTimeout(() => (this.loading = false), 2000);
				console.log(error);
			});
	}
}
